import { useEffect, useState } from "preact/hooks";
import type { RoutableProps } from "preact-router";
import { LegalFooter } from "../components/footer";
import { STRINGS } from "../constants/strings";
import { fetchLegals } from "../legals";

type LegalKind = "privacy" | "imprint";

interface Props extends RoutableProps {
  kind: LegalKind;
}

type State =
  | { status: "loading" }
  | { status: "error" }
  | { status: "ready"; html: string | null };

export function LegalsScreen({ kind }: Props) {
  const [state, setState] = useState<State>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    setState({ status: "loading" });
    fetchLegals()
      .then((legals) => {
        if (cancelled) return;
        const html = kind === "privacy" ? legals.privacyPolicy : legals.imprint;
        setState({ status: "ready", html });
      })
      .catch(() => {
        if (!cancelled) setState({ status: "error" });
      });
    return () => {
      cancelled = true;
    };
  }, [kind]);

  const title =
    kind === "privacy" ? STRINGS.footerPrivacy : STRINGS.footerImprint;

  return (
    <div class="tl-page">
      <div class="tl-page-main">
        <h1 class="tl-screen-title">{title}</h1>
        <div class="tl-card">
          {state.status === "loading" && <p>{STRINGS.loading}</p>}
          {state.status === "error" && (
            <p class="tl-field__error" role="alert">
              {STRINGS.genericError}
            </p>
          )}
          {state.status === "ready" &&
            (state.html ? (
              <div
                class="tl-legal-content"
                dangerouslySetInnerHTML={{ __html: state.html }}
              />
            ) : (
              <p>{STRINGS.legalsEmpty}</p>
            ))}
        </div>
      </div>
      <LegalFooter />
    </div>
  );
}
